import type {
  ChatLlmStreamRequest,
  ChatLlmStreamResult,
  LlmStreamDoc,
} from '../../services/llm';
import type { RunVerifierRequest, RunVerifierResult } from './verifier';

export type {
  ChatLlmStreamRequest,
  ChatLlmStreamResult,
  LlmStreamDoc,
  RunVerifierRequest,
  RunVerifierResult,
};

export type LlmUnsubscribe = () => void;

export interface LlmGateway {
  createStreamDocId: () => string | Promise<string>;
  subscribeToStream: (
    streamDocId: string,
    callback: (stream: LlmStreamDoc | null) => void,
  ) => LlmUnsubscribe | Promise<LlmUnsubscribe>;
  startStream: (request: ChatLlmStreamRequest) => Promise<ChatLlmStreamResult>;
}

export interface VerifierGateway {
  run: (request: RunVerifierRequest) => Promise<RunVerifierResult>;
}

export function createLlmApi(gateway: LlmGateway) {
  return {
    createStreamDocId: async () => gateway.createStreamDocId(),
    subscribeToStream: async (streamDocId: string, callback: (stream: LlmStreamDoc | null) => void) => (
      gateway.subscribeToStream(streamDocId, callback)
    ),
    startStream: (request: ChatLlmStreamRequest) => gateway.startStream(request),
  };
}

export function createVerifierApi(gateway: VerifierGateway) {
  return {
    run: (request: RunVerifierRequest) => gateway.run(request),
  };
}
